import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api, {IMAGE_BASE_URL} from "../../../api/Api.js";
import { Link , useParams, useNavigate} from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

import { CKEditor } from "@ckeditor/ckeditor5-react";

import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Font,
  Alignment,
  List,
  Link as CKLink,
  BlockQuote,
  Table as CKTable,
  TableToolbar,
  Image as CKImage,
  ImageUpload,
  ImageToolbar,
  ImageStyle,
  ImageResize,
  SimpleUploadAdapter,
  HorizontalLine,
} from "ckeditor5";

import "ckeditor5/ckeditor5.css";
import "./VisaAssistanceAdd.css";

const EditPackagePage = () => {
const navigate = useNavigate();
const { packagesId } = useParams();
const imagePath = `${IMAGE_BASE_URL}/uploads/holidays_packages/`;
  // =====================================================
  // BASIC FORM STATES
  // =====================================================

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [title, setTitle] = useState("");
  const [sbTitle, setSbTitle] = useState("");
  const [description, setDescription] = useState("");
  const [getYoutubeLink, setYoutubeLink] = useState("");
  const [content, setContent] = useState("");

  const [metaKey, setMetaKey] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [keyword, setKeyword] = useState("");

  const [addedBy, setAddedBy] = useState("");
const [getSratingPrice, setSratingPrice] = useState(0);
  const [updatedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  // =====================================================
  // PACKAGE SELECTION STATES
  // =====================================================

  const [selectedPackage, setSelectedPackage] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedDuration, setSelectedDuration] = useState("");

  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  // =====================================================
  // DROPDOWN / CHECKBOX DATA
  // =====================================================

  const [categories, setCategories] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [duration, setDuration] = useState([]);
  const [serviceses, setServices] = useState([]);
  const [tabs, setTabs] = useState([]);

  // =====================================================
  // TAB STATES
  // =====================================================

  const [activeTab, setActiveTab] = useState(null);
  const [tabChecks, setTabChecks] = useState({});
  const [tabContents, setTabContents] = useState({});

  // =====================================================
  // PRICE / PROCESSING TIME
  // =====================================================

  const [getProcessTime, setProcessTime] = useState("");
  const [getHourDays, setHourDays] = useState("");

  // =====================================================
  // EXTRA IMAGES
  // =====================================================

  const [imageRows, setImageRows] = useState([
    {
      image: null,
      preview: "",
      altTitle: "",
    },
  ]);

  // =====================================================
  // FAQ
  // =====================================================

  const [faqRows, setFaqRows] = useState([
    {
      question: "",
      answer: "",
    },
  ]);

  // =====================================================
  // VISA / PACKAGE SLUG
  // =====================================================

  const visaLink = title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-");

  // =====================================================
  // FETCH ALL DATA
  // =====================================================

  useEffect(() => {
    fetchCategoryData();
    fetchCountryData();
    fetchStateData();
    fetchCityData();
    fetchDurationData();
    fetchServiceData();
    fetchTabData();
    fetchHolidayDetails();
  }, []);

const fetchHolidayDetails = async () => {
  try {

    const res = await api.get(
      `/adminHolidays/get-holidays-package-by-id/${packagesId}`
    );

    const data = res.data?.data || [];
    setTitle(data.title);
    setSbTitle(data.sb_title);
    setDescription(data.description);
    setYoutubeLink(data.youtube_link);
    setContent(data.page_content);
    setMetaKey(data.meta_key);
    setMetaDescription(data.meta_description);
    setKeyword(data.keyword);
    setSratingPrice(data.srating_price);
    setSelectedPackage(data.package_id);
    setSelectedCountry(data.country_id);
    setSelectedDuration(data.duration_id);
    // setSelectedStates();
    // setSelectedCity();
    // setSelectedServices(data.services);
    console.log("SUCCESS DATA:", data);

  } catch (error) {

   
    console.log("Error Object:", error);

  }
};

  // =====================================================
  // SET FIRST TAB
  // =====================================================

  useEffect(() => {
    if (tabs.length > 0 && activeTab === null) {
      setActiveTab(tabs[0].tab_id);
    }
  }, [tabs, activeTab]);

  // =====================================================
  // AUTO UPDATE ALT TITLE
  // =====================================================

  useEffect(() => {
    setImageRows((prevRows) =>
      prevRows.map((row, index) => ({
        ...row,
        altTitle: visaLink
          ? `${visaLink}-${index + 1}`
          : "",
      }))
    );
  }, [visaLink]);

  // =====================================================
  // FETCH PACKAGE DATA
  // =====================================================

  const fetchCategoryData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-package-name-data"
      );

      setCategories(res.data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load Package Name data");
    }
  };

  // =====================================================
  // FETCH COUNTRY DATA
  // =====================================================

  const fetchCountryData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-package-country-data"
      );

      setCountry(res.data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load Package Country data");
    }
  };

  // =====================================================
  // FETCH STATE DATA
  // =====================================================

  const fetchStateData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-package-state-data"
      );

      setState(res.data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load Package State data");
    }
  };

  // =====================================================
  // FETCH CITY DATA
  // =====================================================

  const fetchCityData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-package-city-data"
      );

      setCity(res.data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load Package City data");
    }
  };

  // =====================================================
  // FETCH DURATION DATA
  // =====================================================

  const fetchDurationData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-package-duration-data"
      );

      setDuration(res.data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load Package Duration data");
    }
  };

  // =====================================================
  // FETCH SERVICES DATA
  // =====================================================

  const fetchServiceData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-package-services-data"
      );

      setServices(res.data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load Package Services data");
    }
  };

  // =====================================================
  // FETCH TAB DATA
  // =====================================================

  const fetchTabData = async () => {
    try {
      const res = await api.get(
        "/adminHolidays/get-holidays-package-tabs-data"
      );

      const tabData = res.data?.data || [];

      setTabs(tabData);

      if (tabData.length > 0) {
        setActiveTab(tabData[0].tab_id);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load Tab data");
    }
  };

  // =====================================================
  // STATE CHECKBOX CHANGE
  // =====================================================

  const handleStateChange = (e) => {
    const value = e.target.value;

    setSelectedStates((prev) =>
      e.target.checked
        ? [...prev, value]
        : prev.filter((item) => item !== value)
    );
  };

  // =====================================================
  // CITY CHECKBOX CHANGE
  // =====================================================

  const handleCityChange = (e) => {
    const value = e.target.value;

    setSelectedCity((prev) =>
      e.target.checked
        ? [...prev, value]
        : prev.filter((item) => item !== value)
    );
  };

  // =====================================================
  // SERVICE CHECKBOX CHANGE
  // =====================================================

  const handleServiceChange = (e) => {
    const value = e.target.value;

    setSelectedServices((prev) =>
      e.target.checked
        ? [...prev, value]
        : prev.filter((item) => item !== value)
    );
  };

  // =====================================================
  // ADD IMAGE ROW
  // =====================================================

  const addImageRow = () => {
    setImageRows((prevRows) => [
      ...prevRows,
      {
        image: null,
        preview: "",
        altTitle: visaLink
          ? `${visaLink}-${prevRows.length + 1}`
          : "",
      },
    ]);
  };

  // =====================================================
  // REMOVE IMAGE ROW
  // =====================================================

  const removeImageRow = async (index) => {
    if (imageRows.length === 1) {
      toast.error("At least one image row is required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Row?",
      text: "Do you want to delete this image row?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    const row = imageRows[index];

    if (row.preview) {
      URL.revokeObjectURL(row.preview);
    }

    setImageRows((prevRows) =>
      prevRows.filter((_, i) => i !== index)
    );
  };

  // =====================================================
  // IMAGE CHANGE
  // =====================================================

  const handleRowImageChange = (index, file) => {
    if (!file) return;

    setImageRows((prevRows) =>
      prevRows.map((row, i) => {
        if (i !== index) return row;

        if (row.preview) {
          URL.revokeObjectURL(row.preview);
        }

        return {
          ...row,
          image: file,
          preview: URL.createObjectURL(file),
        };
      })
    );
  };

  // =====================================================
  // FAQ ADD
  // =====================================================

  const addFaqRow = () => {
    setFaqRows((prevRows) => [
      ...prevRows,
      {
        question: "",
        answer: "",
      },
    ]);
  };

  // =====================================================
  // FAQ REMOVE
  // =====================================================

  const removeFaqRow = async (index) => {
    if (faqRows.length === 1) {
      toast.error("At least one FAQ is required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete FAQ?",
      text: "Do you want to delete this FAQ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes Delete",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    setFaqRows((prevRows) =>
      prevRows.filter((_, i) => i !== index)
    );
  };

  // =====================================================
  // FAQ CHANGE
  // =====================================================

  const handleFaqChange = (index, field, value) => {
    setFaqRows((prevRows) =>
      prevRows.map((row, i) =>
        i === index
          ? {
              ...row,
              [field]: value,
            }
          : row
      )
    );
  };

  // =====================================================
  // TAB CHECKBOX
  // =====================================================

  const handleTabCheck = (tabId, checked) => {
    setTabChecks((prev) => ({
      ...prev,
      [tabId]: checked,
    }));
  };

  // =====================================================
  // TAB CONTENT
  // =====================================================

  const handleTabContentChange = (tabId, data) => {
    setTabContents((prev) => ({
      ...prev,
      [tabId]: data,
    }));
  };

  // =====================================================
  // SAVE PACKAGE
  // =====================================================

  const savePackage = async () => {
    // ---------------------------------------------------
    // VALIDATION
    // ---------------------------------------------------

    if (!selectedPackage) {
      toast.error("Package Name is required");
      return;
    }

    if (!selectedCountry) {
      toast.error("Country is required");
      return;
    }

    if (selectedStates.length === 0) {
      toast.error("Please select at least one State");
      return;
    }

    if (selectedCity.length === 0) {
      toast.error("Please select at least one City");
      return;
    }

    if (!selectedDuration) {
      toast.error("Duration is required");
      return;
    }

    if (selectedServices.length === 0) {
      toast.error("Please select at least one Service");
      return;
    }

    if (!title.trim()) {
      toast.error("Page Title is required");
      return;
    }

    // ---------------------------------------------------
    // CONFIRMATION
    // ---------------------------------------------------

    const confirm = await Swal.fire({
      title: "Save Holidays Package?",
      text: "Do you want to save this Holidays Package?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Save",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    setIsSubmitting(true);

    try {
      // -------------------------------------------------
      // CREATE FORM DATA
      // -------------------------------------------------

      const formData = new FormData();

      formData.append("visaLink", visaLink);
      formData.append("addedBy", addedBy);
      formData.append("addedDt", updatedDate);

      formData.append("package", selectedPackage);
      formData.append("country", selectedCountry);

      formData.append(
        "state",
        JSON.stringify(selectedStates)
      );

      formData.append(
        "city",
        JSON.stringify(selectedCity)
      );

      formData.append(
        "duration",
        selectedDuration
      );

      formData.append(
        "services",
        JSON.stringify(selectedServices)
      );

      formData.append("title", title);
      formData.append("sbTitle", sbTitle);
      formData.append("description", description);
      formData.append("pageContent", content);

      formData.append(
        "youTube_link",
        getYoutubeLink
      );

      formData.append("metaKey", metaKey);
      formData.append(
        "metaDescription",
        metaDescription
      );
      formData.append("keyword", keyword);

      formData.append(
        "sratingPrice",
        getSratingPrice
      );

      formData.append(
        "processTime",
        getProcessTime
      );

      formData.append(
        "hourDays",
        getHourDays
      );

      // -------------------------------------------------
      // TABS
      // -------------------------------------------------

      const tabsData = tabs.map((tab) => ({
        tab_id: tab.tab_id,
        name: tab.name,
        checked: tabChecks[tab.tab_id] || false,
        content: tabContents[tab.tab_id] || "",
      }));

      formData.append(
        "tabsData",
        JSON.stringify(tabsData)
      );

      // -------------------------------------------------
      // FAQ
      // -------------------------------------------------

      formData.append(
        "faqData",
        JSON.stringify(faqRows)
      );

      // -------------------------------------------------
      // EXTRA IMAGES
      // -------------------------------------------------

      imageRows.forEach((row, index) => {
        if (row.image) {
          formData.append(
            "extraImages",
            row.image
          );
        }

        formData.append(
          `altTitle_${index}`,
          row.altTitle
        );
      });

      // -------------------------------------------------
      // API CALL
      // -------------------------------------------------

      const res = await api.post(
        "/adminHolidays/saveVisa",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // -------------------------------------------------
      // SUCCESS
      // -------------------------------------------------

      if (res.data?.success) {
        await Swal.fire({
          title: "Success",
          text: "Holidays Package Saved Successfully",
          icon: "success",
          confirmButtonText: "OK",
        });

        navigate("/holidays/holiday-packages-manage");
      } else {
        Swal.fire({
          title: "Error",
          text:
            res.data?.message ||
            "Unable to save Holidays Package",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Save Package Error:", error);

      toast.error(
        error.response?.data?.message ||
          "Server Error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // =====================================================
  // CLEANUP OBJECT URLS
  // =====================================================

  useEffect(() => {
    return () => {
      imageRows.forEach((row) => {
        if (row.preview) {
          URL.revokeObjectURL(row.preview);
        }
      });
    };
  }, []);

  // =====================================================
  // RENDER
  // =====================================================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* =================================================
          HEADER
      ================================================= */}

      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between align-items-center">

          <h4 className="fw-bold mb-0">
            Edit Holidays Package
          </h4>

          <Link
            to="/holidays-packages-manage"
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back
          </Link>

        </div>
      </div>

      {/* =================================================
          MAIN FORM
      ================================================= */}

      <div className="row">
        <div className="col-lg-12">

          <table className="table table-bordered">
            <tbody>

              {/* =================================================
                  VISA / PACKAGE LINK
              ================================================= */}

              {title.length > 0 && (
                <tr>
                  <th colSpan={2}>
                    <div className="d-flex align-items-center gap-2">

                      <i
                        className="fa fa-link text-primary"
                        aria-hidden="true"
                      />

                      <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={visaLink}
                      />

                    </div>
                  </th>
                </tr>
              )}

              {/* =================================================
                  META TITLE
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  <div className="d-flex align-items-center gap-2">
                    <span>Meta Title</span>

                    <small
                      className={
                        metaKey.length >= 79
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      ({metaKey.length}/80 Characters)
                    </small>
                  </div>
                </th>
              </tr>

              <tr>
                <td colSpan={2}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Meta Title"
                    value={metaKey}
                    maxLength={80}
                    onChange={(e) =>
                      setMetaKey(e.target.value)
                    }
                  />

                  {metaKey.length >= 79 && (
                    <small className="text-danger">
                      ⚠️ Almost reached limit
                    </small>
                  )}
                </td>
              </tr>

              {/* =================================================
                  META DESCRIPTION
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  <div className="d-flex align-items-center gap-2">
                    <span>Meta Description</span>

                    <small
                      className={
                        metaDescription.length >= 159
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      ({metaDescription.length}/160 Characters)
                    </small>
                  </div>
                </th>
              </tr>

              <tr>
                <td colSpan={2}>
                  <textarea
                    rows="3"
                    className="form-control"
                    placeholder="Enter Meta Description"
                    value={metaDescription}
                    maxLength={160}
                    onChange={(e) =>
                      setMetaDescription(
                        e.target.value
                      )
                    }
                  />

                  {metaDescription.length >= 159 && (
                    <small className="text-danger">
                      ⚠️ Almost reached limit
                    </small>
                  )}
                </td>
              </tr>

              {/* =================================================
                  META KEYWORD
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  <div className="d-flex align-items-center gap-2">
                    <span>Meta Keyword</span>

                    <small
                      className={
                        keyword.length >= 254
                          ? "text-danger"
                          : "text-muted"
                      }
                    >
                      ({keyword.length}/255 Characters)
                    </small>
                  </div>
                </th>
              </tr>

              <tr>
                <td colSpan={2}>
                  <textarea
                    rows="3"
                    className="form-control"
                    placeholder="Enter Keyword"
                    value={keyword}
                    maxLength={255}
                    onChange={(e) =>
                      setKeyword(e.target.value)
                    }
                  />

                  {keyword.length >= 254 && (
                    <small className="text-danger">
                      ⚠️ Almost reached limit
                    </small>
                  )}
                </td>
              </tr>

              {/* =================================================
                  PACKAGE / COUNTRY
              ================================================= */}

              <tr>
                <th>Package Name</th>
                <th>Country</th>
              </tr>

              <tr>

                {/* PACKAGE */}

                <td>
                  <select
                    className="form-control"
                    value={selectedPackage}
                    onChange={(e) =>
                      setSelectedPackage(
                        e.target.value
                      )
                    }
                  >
                    <option value="">
                      -- Select Package --
                    </option>

                    {categories.map((cat) => (
                      <option
                        key={cat.packages_id}
                        value={cat.packages_slug}
                      >
                        {cat.packages_name}
                      </option>
                    ))}
                  </select>
                </td>

                {/* COUNTRY */}

                <td>
                  <select
                    className="form-control"
                    value={selectedCountry}
                    onChange={(e) =>
                      setSelectedCountry(
                        e.target.value
                      )
                    }
                  >
                    <option value="">
                      -- Select Country --
                    </option>

                    {country.map((cat) => (
                      <option
                        key={cat.cntry_id}
                        value={cat.slug}
                      >
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </td>

              </tr>

              {/* =================================================
                  STATE / CITY
              ================================================= */}

              <tr>
                <th colSpan={2}>State</th>
              </tr>

                

              <tr>

                {/* STATE */}

                <td colSpan={2}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px 20px",
                    }}
                  >
                    {state.map((cat) => (
                      <div
                        className="form-check"
                        key={cat.state_id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          margin: 0,
                        }}
                      >

                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`state-${cat.state_id}`}
                          value={cat.slug}
                          checked={selectedStates.includes(
                            cat.slug
                          )}
                          onChange={
                            handleStateChange
                          }
                        />

                        <label
                          className="form-check-label"
                          htmlFor={`state-${cat.state_id}`}
                        >
                          {cat.state
                            ?.toLowerCase()
                            .replace(
                              /\b\w/g,
                              (char) =>
                                char.toUpperCase()
                            )}
                        </label>

                      </div>
                    ))}
                  </div>
                </td>

                </tr>
<tr>
                <th colSpan={2}>City</th>
              </tr>
                {/* CITY */}
<tr>
                <td colSpan={2}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px 20px",
                    }}
                  >
                    {city.map((cat) => (
                      <div
                        className="form-check"
                        key={cat.city_id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          margin: 0,
                        }}
                      >

                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`city-${cat.city_id}`}
                          value={cat.city_slug}
                          checked={selectedCity.includes(
                            cat.city_slug
                          )}
                          onChange={
                            handleCityChange
                          }
                        />

                        <label
                          className="form-check-label"
                          htmlFor={`city-${cat.city_id}`}
                        >
                          {cat.city_name
                            ?.toLowerCase()
                            .replace(
                              /\b\w/g,
                              (char) =>
                                char.toUpperCase()
                            )}
                        </label>

                      </div>
                    ))}
                  </div>
                </td>

              </tr>

              {/* =================================================
                  DURATION / SERVICES
              ================================================= */}

              <tr>
                <th colSpan={2}>Services Included</th>
              </tr>

              <tr>

                {/* DURATION */}


                {/* SERVICES */}

                <td colSpan={2}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px 20px",
                    }}
                  >
                    {serviceses.map((cat) => (
                      <div
                        className="form-check"
                        key={cat.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          margin: 0,
                        }}
                      >

                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`service-${cat.id}`}
                          value={String(cat.id)}
                          checked={selectedServices.includes(
                            String(cat.id)
                          )}
                          onChange={
                            handleServiceChange
                          }
                        />

                        <label
                          className="form-check-label"
                          htmlFor={`service-${cat.id}`}
                        >
                          {cat.service_name}
                        </label>

                      </div>
                    ))}
                  </div>
                </td>

              </tr>

              {/* =================================================
                  PAGE TITLE / SUB TITLE
              ================================================= */}

              <tr>
                <th>Page Title</th>
                <th>Page Sub Title</th>
              </tr>

              <tr>

                <td>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Title"
                    value={title}
                    onChange={(e) =>
                      setTitle(e.target.value)
                    }
                  />
                </td>

                <td>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Sub Title"
                    value={sbTitle}
                    onChange={(e) =>
                      setSbTitle(e.target.value)
                    }
                  />
                </td>

              </tr>

              {/* =================================================
                  PRICE / PROCESSING TIME
              ================================================= */}

              <tr>
                <th>Price Per Person</th>
                
                <th>Duration</th>
              </tr>

              <tr>

                <td>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Starting Price"
                    value={getSratingPrice}
                    onChange={(e) =>
                      setSratingPrice(
                        e.target.value
                      )
                    }
                  />
                </td>

                
                <td>
                  <select
                    className="form-control"
                    value={selectedDuration}
                    onChange={(e) =>
                      setSelectedDuration(
                        e.target.value
                      )
                    }
                  >
                    <option value="">
                      -- Select Duration --
                    </option>

                    {duration.map((cat) => (
                      <option
                        key={cat.id}
                        value={cat.id}
                      >
                        {cat.days} Day -{" "}
                        {cat.nights} Night
                      </option>
                    ))}
                  </select>
                </td>

              </tr>

              {/* =================================================
                  TAB DETAILS
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  Tab Details
                </th>
              </tr>

              <tr>
                <td colSpan={2}>

                  <ul className="nav nav-tabs">

                    {tabs.map((tab) => (
                      <li
                        key={tab.tab_id}
                        className={`custom-tab ${
                          activeTab === tab.tab_id
                            ? "tab-active"
                            : "tab-inactive"
                        }`}
                      >
                        <button
                          type="button"
                          onClick={() =>
                            setActiveTab(
                              tab.tab_id
                            )
                          }
                          style={{
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            padding: "8px 12px",
                          }}
                        >
                          {tab.name}
                        </button>
                      </li>
                    ))}

                  </ul>

                  <div className="tab-content mt-2">

                    {tabs.map((tab) =>
                      activeTab === tab.tab_id ? (
                        <div key={tab.tab_id}>

                          {/* TAB ENABLE */}

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              backgroundColor:
                                "#ff6c26",
                              color: "#fff",
                              fontWeight: "600",
                              padding: "5px",
                            }}
                          >

                            <input
                              type="checkbox"
                              checked={
                                tabChecks[
                                  tab.tab_id
                                ] || false
                              }
                              onChange={(e) =>
                                handleTabCheck(
                                  tab.tab_id,
                                  e.target.checked
                                )
                              }
                            />

                            <p
                              style={{
                                marginLeft: "5px",
                                marginBottom: 0,
                              }}
                            >
                              {tab.name}
                            </p>

                          </div>

                          {/* TAB EDITOR */}

                          <CKEditor
                            editor={ClassicEditor}
                            data={
                              tabContents[
                                tab.tab_id
                              ] || ""
                            }
                            config={{
                              licenseKey: "GPL",

                              plugins: [
                                Essentials,
                                Paragraph,
                                Heading,
                                Bold,
                                Italic,
                                Underline,
                                Font,
                                Alignment,
                                List,
                                CKLink,
                                BlockQuote,
                                CKTable,
                                TableToolbar,
                                CKImage,
                                ImageUpload,
                                ImageToolbar,
                                ImageStyle,
                                ImageResize,
                                SimpleUploadAdapter,
                                HorizontalLine,
                              ],

                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "underline",
                                "|",
                                "fontSize",
                                "fontColor",
                                "fontBackgroundColor",
                                "|",
                                "alignment",
                                "|",
                                "bulletedList",
                                "numberedList",
                                "|",
                                "link",
                                "blockQuote",
                                "insertTable",
                                "|",
                                "imageUpload",
                                "horizontalLine",
                                "|",
                                "undo",
                                "redo",
                              ],

                              table: {
                                contentToolbar: [
                                  "tableColumn",
                                  "tableRow",
                                  "mergeTableCells",
                                ],
                              },

                              simpleUpload: {
                                uploadUrl:
                                  "http://localhost:5000/api/upload-editor-image",
                              },
                            }}
                            onChange={(
                              event,
                              editor
                            ) => {
                              handleTabContentChange(
                                tab.tab_id,
                                editor.getData()
                              );
                            }}
                          />

                        </div>
                      ) : null
                    )}

                  </div>

                </td>
              </tr>

              {/* =================================================
                  FAQ
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  FAQ Details
                </th>
              </tr>

              <tr>
                <td colSpan={2}>

                  <table className="table table-hover table-bordered align-middle mb-0">

                    <thead className="table-light">
                      <tr>
                        <th width="50">#</th>
                        <th>Question</th>
                        <th>Answer</th>
                        <th width="120">
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody>

                      {faqRows.map(
                        (row, index) => (
                          <tr key={index}>

                            <td>
                              {index + 1}
                            </td>

                            <td>
                              <textarea
                                className="form-control"
                                placeholder="Enter Question"
                                value={
                                  row.question
                                }
                                onChange={(e) =>
                                  handleFaqChange(
                                    index,
                                    "question",
                                    e.target.value
                                  )
                                }
                              />
                            </td>

                            <td>
                              <textarea
                                className="form-control"
                                placeholder="Enter Answer"
                                value={
                                  row.answer
                                }
                                onChange={(e) =>
                                  handleFaqChange(
                                    index,
                                    "answer",
                                    e.target.value
                                  )
                                }
                              />
                            </td>

                            <td>

                              <button
                                type="button"
                                className="btn btn-success btn-sm me-2"
                                onClick={
                                  addFaqRow
                                }
                              >
                                <i className="fa fa-plus-square" />
                              </button>

                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() =>
                                  removeFaqRow(
                                    index
                                  )
                                }
                              >
                                <i className="fa fa-trash" />
                              </button>

                            </td>

                          </tr>
                        )
                      )}

                    </tbody>

                  </table>

                </td>
              </tr>

              {/* =================================================
                  YOUTUBE LINK
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  YouTube Link
                </th>
              </tr>

              <tr>
                <td colSpan={2}>
                  <textarea
                    rows="3"
                    className="form-control"
                    placeholder="Enter YouTube Link"
                    value={getYoutubeLink}
                    onChange={(e) =>
                      setYoutubeLink(
                        e.target.value
                      )
                    }
                  />
                </td>
              </tr>

              {/* =================================================
                  DESCRIPTION
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  Page Description
                </th>
              </tr>

              <tr>
                <td colSpan={2}>
                  <textarea
                    rows="4"
                    className="form-control"
                    placeholder="Enter Description"
                    value={description}
                    onChange={(e) =>
                      setDescription(
                        e.target.value
                      )
                    }
                  />
                </td>
              </tr>

              {/* =================================================
                  PAGE CONTENT
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  Page Detailed Content
                </th>
              </tr>

              <tr>
                <td colSpan={2}>

                  <CKEditor
                    editor={ClassicEditor}
                    data={content}
                    config={{
                      licenseKey: "GPL",

                      plugins: [
                        Essentials,
                        Paragraph,
                        Heading,
                        Bold,
                        Italic,
                        Underline,
                        Font,
                        Alignment,
                        List,
                        CKLink,
                        BlockQuote,
                        CKTable,
                        TableToolbar,
                        CKImage,
                        ImageUpload,
                        ImageToolbar,
                        ImageStyle,
                        ImageResize,
                        SimpleUploadAdapter,
                        HorizontalLine,
                      ],

                      toolbar: [
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "underline",
                        "|",
                        "fontSize",
                        "fontColor",
                        "fontBackgroundColor",
                        "|",
                        "alignment",
                        "|",
                        "bulletedList",
                        "numberedList",
                        "|",
                        "link",
                        "blockQuote",
                        "insertTable",
                        "|",
                        "imageUpload",
                        "horizontalLine",
                        "|",
                        "undo",
                        "redo",
                      ],

                      table: {
                        contentToolbar: [
                          "tableColumn",
                          "tableRow",
                          "mergeTableCells",
                        ],
                      },

                      simpleUpload: {
                        uploadUrl:
                          "http://localhost:5000/api/upload-editor-image",
                      },
                    }}
                    onChange={(
                      event,
                      editor
                    ) => {
                      setContent(
                        editor.getData()
                      );
                    }}
                  />

                </td>
              </tr>

              {/* =================================================
                  EXTRA IMAGE TABLE
              ================================================= */}

                <tr>
                  <th colSpan={2}>
                     <table className="table table-hover table-bordered">
                        <thead>
                           <tr>
                              <th>#</th>
                              <th>Upload Image {}</th>
                              <th>Alt Title</th>
                              <th>Image Preview</th>
                              <th>Action</th>
                           </tr>
                        </thead>
                        <tbody>
                          {/* <pre>
  {JSON.stringify(imageRows, null, 2)}
</pre> */}
                           {imageRows.map((row, index) => (
                           <tr key={index}>
                              <td>{index + 1} </td>
                              <td>
                                 <input type="file" className="form-control"
                                    onChange={(e) => handleRowImageChange(index, e.target.files[0])}
                                 />
                              </td>
                              <td>
                               {/* <input
  className="form-control"
  value={row.altTitle || ""} 
  onChange={(e) => handleAltTitleChange(index, e.target.value)}
/> */}


<input
  className="form-control"
  value={row.altTitle || ""}
  readOnly
/>
                              </td>
                              <td style={{textAlign:"center"}}>
                                 {(row.preview || row.oldImage) && (
                                 <img
                                 src={row.preview || `${imagePath}${row.oldImage}`}
                                 width="70"
                                 height="70"
                                 className="mt-2 rounded border"
                                 />
                                 )}
                              </td>
                              <td>
                                 <button className="btn btn-success btn-sm" onClick={addImageRow}>+</button>
                                 <button className="btn btn-danger btn-sm" onClick={() => removeImageRow(index)}>x</button>
                              </td>
                           </tr>
                           ))}
                        </tbody>
                     </table>
                  </th>
               </tr>

              {/* =================================================
                  ADDED BY
              ================================================= */}

              <tr>
                <th colSpan={2}>
                  Added By
                </th>
              </tr>

              <tr>
                <td colSpan={2}>

                  <input
                    className="form-control"
                    placeholder="Enter Name"
                    type="text"
                    value={addedBy}
                    onChange={(e) =>
                      setAddedBy(
                        e.target.value
                      )
                    }
                  />

                </td>
              </tr>

            </tbody>
          </table>

        </div>

        {/* =================================================
            SAVE BUTTON
        ================================================= */}

        <div className="col-lg-12 text-center">

          <button
            type="button"
            className="btn btn-info text-white px-5 mt-3"
            onClick={savePackage}
            disabled={isSubmitting}
          >

            {isSubmitting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />

                Submitting...
              </>
            ) : (
              "Save Holidays Package"
            )}

          </button>

        </div>

      </div>
    </div>
  );
};

export default EditPackagePage;